import React from 'react';

import SkewBg from '#common/SkewBg';
import PageHeader from '#common/PageHeader';
import Flex from '#common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faTrophy } from '@fortawesome/free-solid-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Card, CardIcon, CardText } from '#common/Card';
import Quote from './Quote';
import Avatar from './Avatar';

import { AboutWrapper, AboutInfo } from './About.style';

const Awards = () => (
  <Flex justify="space-between" align="center">
    <Card>
      <CardIcon>
        <FontAwesomeIcon icon={faTrophy} />
      </CardIcon>

      <CardText>The first Arab girl teaching how to code on YouTube.</CardText>
    </Card>

    <Card>
      <CardIcon>
        <FontAwesomeIcon icon={faYoutube} />
      </CardIcon>

      <CardText>Winner of the best YouTuber award in the competition of YouTube nextup 2017</CardText>
    </Card>

    <Card>
      <CardIcon>
        <FontAwesomeIcon icon={faAward} />
      </CardIcon>

      <CardText>The biggest influencer on social media In North Africa.</CardText>
    </Card>
  </Flex>
);
const About = () => {
  return (
    <AboutWrapper id="about">
      <PageHeader> About Me</PageHeader>
      <SkewBg />
      <AboutInfo>
        <div>
          <Avatar src="hfest_avatar_2.jpg" />
        </div>
        <p>
          My name is Samar Tekaya and I'm 24 years old. Since I started my studies on IT bachelor degree, my story of
          passion to the coding and programming began. I had fun when I could fix bugs, It taught me a lot of patience,
          and there where I found myself talking about my passion of coding and design on my YouTube channel. Honestly,
          I didn't like being like everyone else in the university, coming and going, falling into the routine. I wanna
          be creative, learn and share my knowledge with people, I always wanted to be special in this domain. I was
          working as a freelancer with companies outside Tunisia and studying at the same time. Then I experienced
          teaching in workshops and trainings in many different places in Tunisia.
          <br />
          <br />I was asking myself "what if I open my own startup?" and there I started SamCoding : Software company. Also I had the
          chance to work as a chronicler in a TV show called M Tunisia but I couldn't continue because of my
          engagements. Besides that I worked as a mobile developer in a French Company using react native technology.
          This is me Guys! I have IT Licence degree, Front-end developer, Freelancer, Content creator and of course the
          CEO and Founder of SamCoding. With my passion to learn and my willingness to work nothing will stop me from
          reaching my goals!
        </p>
      </AboutInfo>

      <Flex justify="space-between" className="quotes__wrapper">
        <Quote>
          <p>“Do what you love - love what you do.”</p>
        </Quote>
        <Quote>
          <p>“Ever positive - never negative.“</p>
        </Quote>
        <Quote>
          <p>“Code never lies, comments sometimes do.”</p>
        </Quote>
      </Flex>
      <PageHeader className="awards__wrapper">Awards</PageHeader>
      <Awards />
    </AboutWrapper>
  );
};

export default About;
